export const useCircleV4 = () => ({
  isCircleV4: Boolean(window.V4_UI),
  isCircleV4Eligible: Boolean(window.V4_ELIGIBLE),
  isCircleV4OptInEnabled: Boolean(window.V4_OPT_IN_ENABLED),
  isCircleV4PreviewEnabled: Boolean(window.V4_PREVIEW),
  isCircleV4Enabled: Boolean(window.V4_ENABLED),
});
